import { render, staticRenderFns } from "./SummaryInfo.vue?vue&type=template&id=4272845a&scoped=true"
import script from "./SummaryInfo.vue?vue&type=script&lang=js"
export * from "./SummaryInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4272845a",
  null
  
)

export default component.exports